import { useSelector } from 'react-redux';
import { ApplicationState } from '../store';
import { useLocation, useNavigate, generatePath } from 'react-router-dom';
import { defaultRoutes } from '../routes';
import { getPageByIndex } from '../utilities/routing-utilities';
import { useCallback } from 'react';
import { studentBaseUrl } from '../App';

export const useCustomNavigate = () => {
  const uni = useSelector((state: ApplicationState) => state.student.core.university);
  const studentNumber = useSelector((state: ApplicationState) => state.student.core.student_id.split('#')[1]);
  const intakeId = useSelector((state: ApplicationState) => state.student.offer.intakeId);
  const offerId = useSelector((state: ApplicationState) => state.student.offer.offerId);
  // @ts-expect-error - recordedInterviews is not in IOffer type but exists at runtime
  const recordedInterviews = useSelector((state: ApplicationState) => state.student.offer.recordedInterviews);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPathname = location.pathname;
  const endpoints = defaultRoutes();
  const nextUrl = getPageByIndex(endpoints, currentPathname, currentindex => currentindex + 1) || '';
  const params = {
    uni,
    id: studentNumber ?? '',
    intakeId,
    offerId,
    interviewHash: undefined,
    userId: undefined,
    applicationId: undefined,
  };
  if (nextUrl.includes('interviewHash')) {
    if (Object.keys(recordedInterviews ?? {}).length) {
      params.interviewHash = Object.keys(recordedInterviews)[0];
    } else {
      params.interviewHash = '';
    }
  }
  if (nextUrl.includes('applicationId')) {
    params.userId = '12345';
    params.applicationId = '1234';
  }
  const nextUrlWithParams = generatePath(nextUrl, params);
  const navigateForward = useCallback(() => {
    navigate(nextUrlWithParams);
  }, [navigate, nextUrlWithParams]);

  const navigateToStudentDashboard = () => {
    navigate(`${studentBaseUrl}/${uni}/${studentNumber}/${intakeId}/${offerId}`);
  };

  const navigateBackward = () => {
    const previousUrl = getPageByIndex(endpoints, location.pathname, currentindex => currentindex - 1);
    const previousUrlWithParams = generatePath(previousUrl, { uni, id: studentNumber, intakeId, offerId });
    navigate(`${studentBaseUrl}${previousUrlWithParams}`);
  };

  const navigateTo = useCallback(
    (url: string) => {
      navigate({
        pathname: `${studentBaseUrl}/${uni}/${studentNumber}/${intakeId}/${url}`,
        search: '',
        hash: '',
      });
    },
    [intakeId, navigate, studentNumber, uni],
  );

  return { navigateForward, navigateToStudentDashboard, navigateBackward, navigateTo };
};
